import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { UserService } from '../auth/_services/user.service';
import { widgetDashboard } from './widget-dashboard.model';
import { LayoutUtilsService, MessageType } from "../_base/crud";
import moment from 'moment';
import { IDrillDownObject, IGroupByChartDrillDownObject } from './widget-dashboard.interface';
const API_URL = environment.API_URL;
@Injectable({
  providedIn: 'root'
})
export class WidgetDashboardService {
  timeRangeChanged = new EventEmitter<any>();
  isDashboardEditable = false;
  widgetData = {}
  timeRangeData = {}
  isDashboardChanged = false
  dashboards = []
  colors = ["#000083", "#c71585", "#765aaf", "#fc6300", "#800000", "#b34a7e", "#0288cb", "#3b51ff", "#1f7362", "#b38135", "#33339c", "#d2449d", "#9370db", "#fd8233", "#993333", "#ff69b4", "#35a0d5", "#6274ff", "#34bfa3", "#ffb84c", "#6666b5", "#dd73b6", "#a98de2", "#fda166", "#b36666", "#ff87c3", "#67b8e0", "#8997ff", "#71d2bf", "#ffcd82", "#EEE8AA", "#FF8C00", "#E0FFFF", "#87CEFA", "#A0522D", "#F5DEB3", "#F5F5DC", "#FFB6C1", "#FFDAB9", "#8B008B", "#FFDAB9", "#B8860B", "#D8BFD8", "#FFE4B5", "#DAA520", "#BDB76B", "#F0FFF0", "#F5F5F5", "#EEE8AA", "#FFA07A", "#FFE4C4", "#D3D3D3", "#A9A9A9", "#D2691E", "#F4A460", "#DCDCDC", "#B0E0E6", "#DA70D6", "#B8860B", "#FFA500", "#F5F5F5", "#FFC0CB", "#FFA07A", "#EEE8AA", "#808080", "#FFDAB9", "#F0E68C", "#FFB6C1", "#A0522D", "#D3D3D3", "#A9A9A9", "#F5DEB3", "#FFDAB9", "#F5F5F5", "#FFC0CB", "#F5F5DC", "#E6E6FA", "#DAA520", "#FFD700", "#FA8072", "#FFEFD5", "#FFB6C1", "#FF69B4", "#A9A9A9", "#D2B48C", "#8FBC8F", "#FFF0F5", "#F0EAD6", "#FFA07A", "#F4A460", "#D8BFD8", "#F0FFF0", "#F5F5F5", "#F0EAD6", "#E6E6FA", "#F0FFF0", "#FFF0F5", "#FFF8DC", "#FFDAB9", "#F0F8FF", "#F5F5DC"]
  // colors = ["#2f60ff", "#6976fe", "#8d8dfc", "#aaa5fa", "#c3bef7", "#e2cff5", "#d1adf8", "#be8bfb", "#a768fd", "#8c42fe", "#6a00ff", "#d45087", "#dc6e98", "#e289a9", "#e8a4ba", "#ecbdcc", "#f7dad9", "#fbc3c2", "#fdabab", "#fe9395", "#fe9395", "#f95d6a", "#e6c230", "#edcd67", "#f2d996", "#f3e4c3", "#d7eed4", "#bcebb7", "#9fe89b", "#7fe47e"];
  timeRange = [
    {
      id: 1,
      name: 'Last 1 Hour',
      window: 1,
      unit: 'h',
      trendWindow: 5,
      trendUnit: 'm'
    },
    {
      id: 2,
      name: 'Last 4 Hours',
      window: 4,
      unit: 'h',
      trendWindow: 5,
      trendUnit: 'm'
    },
    {
      id: 3,
      name: 'Last 8 Hours',
      window: 8,
      unit: 'h',
      trendWindow: 5,
      trendUnit: 'm'
    },
    {
      id: 4,
      name: 'Last 12 Hours',
      window: 12,
      unit: 'h',
      trendWindow: 1,
      trendUnit: 'h'
    },
    {
      id: 5,
      name: 'Last 24 Hours',
      window: 24,
      unit: 'h',
      trendWindow: 1,
      trendUnit: 'h'
    },
    {
      id: 6,
      name: 'Today',
      window: 1,
      unit: 'd',
      trendWindow: 1,
      trendUnit: 'h'
    },
    {
      id: 7,
      name: 'Yesterday',
      window: 1,
      unit: 'd',
      trendWindow: 1,
      trendUnit: 'h'
    },
    {
      id: 8,
      name: 'Last 7 Days',
      window: 1,
      unit: 'w',
      trendWindow: 1,
      trendUnit: 'd'
    },
    {
      id: 9,
      name: 'This Week',
      window: 1,
      unit: 'w',
      trendWindow: 1,
      trendUnit: 'd'
    },
    {
      id: 10,
      name: 'Previous Week',
      window: 1,
      unit: 'w',
      trendWindow: 1,
      trendUnit: 'd'
    },
    {
      id: 11,
      name: 'Last 15 Days',
      window: 15,
      unit: 'd',
      trendWindow: 1,
      trendUnit: 'd'
    },
    {
      id: 12,
      name: 'Last 30 Days',
      window: 30,
      unit: 'd',
      trendWindow: 1,
      trendUnit: 'd'
    },
    {
      id: 13,
      name: 'This Month',
      window: 30,
      unit: 'd',
      trendWindow: 1,
      trendUnit: 'd'
    },
    {
      id: 14,
      name: 'Previous Month',
      window: 30,
      unit: 'd',
      trendWindow: 1,
      trendUnit: 'd'
    },
    {
      id: 15,
      name: 'Last 3 Months',
      window: 90,
      unit: 'd',
      trendWindow: 7,
      trendUnit: 'd'
    },
    {
      id: 16,
      name: 'Last 6 Months',
      window: 180,
      unit: 'd',
      trendWindow: 7,
      trendUnit: 'd'
    },
    {
      id: 17,
      name: 'Last 12 Months',
      window: 360,
      unit: 'd',
      trendWindow: 30,
      trendUnit: 'd'
    },
    {
      id: 18,
      name: 'This Year',
      window: 720,
      unit: 'd',
      trendWindow: 30,
      trendUnit: 'd'
    },
    {
      id: 19,
      name: 'Previous Year',
      window: 360,
      unit: 'd',
      trendWindow: 30,
      trendUnit: 'd'
    }
  ]
  chartMetaData: any = {
    '13': {
      pivotOptions: ['value'],
      pivot: 'value',
      extraInputs: [
        {
          key: 'value',//to be used as the form control name
          type: 'number',
          show: true
        },
        {
          key: 'measure',
          type: 'dropdown',
          show: true,
          options: [{
            label: 'Absolute',
            value: 'absolute'
          }, {
            label: 'Relative',
            value: 'relative'
          },
          {
            label: 'Total',
            value: 'total'
          }]
        },
        {
          key: 'dv',
          show: false,
          type: 'text'
        }
      ]
    },
    '14': {
      pivotOptions: ['label', 'unit'], //TODO: unit, system, tag etc to be added
      pivot: 'label', //if pivot is extraInputs, groupFor is label and vice versa
      groupFor: 'unit',
      extraInputs: [{
        key: 'value',//to be used as the form control name
        label: 'Value',
        type: 'number',
        show: true
      }]
    },
    '15': {
      pivotOptions: ['label'], //TODO: unit, system, tag etc to be added
      pivot: 'label', //if pivot is extraInputs, groupFor is label and vice versa
      extraInputs: [{
        key: 'dv_value',//to be used as the form control name
        label: 'Design',
        type: 'number',
        show: true,
        line: {
          dash: 'dot',
          color: '#C996FF'
        }
      },
      {
        key: 'value',//to be used as the form control name
        label: 'Actual',
        type: 'number',
        show: true,
        line: {
          dash: 'solid',
          color: '#2E60FF'
        }
      }]
    }
  }
  graphTypes = {
    "Time Series": [
      {
        "_id": 1,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 16, 19],
        "title": "lines",
        "icon": "show_chart",
        "menuLinkText": "Line Chart",
        "description": "Time based line, area and bar charts",
        "__v": 0
      },
      {
        "_id": 2,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 16, 19],
        "title": "bar",
        "icon": "bar_chart",
        "menuLinkText": "Bar Chart",
        "description": "Time based line, area and bar charts",
        "__v": 0
      },
      {
        "_id": 3,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 16, 19],
        "title": "markers",
        "icon": "scatter_plot",
        "menuLinkText": "Marker Chart",
        "description": "Markers plots",
        "__v": 0
      },
      {
        "_id": 5,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 16, 19],
        "title": "area",
        "icon": "area_chart",
        "menuLinkText": "Area Chart",
        "description": "Time based line, area and bar charts",
        "__v": 0
      },
      {
        "_id": 7,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 16, 19],
        "title": "heatmap",
        "icon": "space_dashboard",
        "menuLinkText": "Heatmap Chart",
        "description": "Heatmap graphs",
        "__v": 0
      },
      {
        "_id": 6,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 16, 19],
        "title": "histogram",
        "icon": "leaderboard",
        "menuLinkText": "Histogram Chart",
        "description": "Like a histogram over time",
        "__v": 0
      },
      {
        "_id": 19,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 16, 19],
        "title": "box",
        "icon": "candlestick_chart",
        "menuLinkText": "Box Chart",
        "description": "Like a box plot",
        "__v": 0
      }
    ],
    "Non Time Series": [
      {
        "_id": 4,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 16, 19],
        "title": "pie",
        "icon": "pie_chart",
        "menuLinkText": "Pie Chart",
        "description": "The new core pie chart visualization",
        "__v": 0
      },
      {
        "_id": 8,
        "compact": [8, 9, 10],
        "title": "sunburst",
        "icon": "wb_sunny",
        "menuLinkText": "Sun Burst Chart",
        "description": "Sun Burst Charts",
        "__v": 0
      },
      {
        "_id": 9,
        "compact": [8, 9, 10],
        "title": "hierarchychart",
        "icon": "auto_graph",
        "menuLinkText": "Hierarchy Chart",
        "description": "Hierarchy Charts",
        "__v": 0
      },
      {
        "_id": 11,
        "compact": [11],
        "title": "singlestats",
        "icon": "query_stats",
        "menuLinkText": "Single Stats Chart",
        "description": "Single Stats",
        "__v": 0
      },
      {
        "_id": 10,
        "compact": [8, 9, 10],
        "title": "treemap",
        "icon": "account_tree",
        "menuLinkText": "TreeMap Chart",
        "description": "TreeMap Charts",
        "__v": 0
      },
      {
        "_id": 14,
        "compact": [14, 1, 2, 3, 4, 5, 6, 7, 16],
        "title": "bar",
        "icon": "bar_chart",
        "menuLinkText": "Bar Chart",
        "description": "Categorical charts with group support",
        "__v": 0
      },
      {
        "_id": 13,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 13, 14, 16, 19],
        "title": "waterfall",
        "icon": "waterfall_chart",
        "menuLinkText": "Waterfall Chart",
        "description": "Waterfall Charts",
        "__v": 0
      },
      {
        "_id": 15,
        "compact": [1, 2, 3, 4, 5, 6, 7, 12, 14, 15],
        "title": "surveychart",
        "icon": "stacked_line_chart",
        "menuLinkText": "Survey Chart",
        "description": "",
        "__v": 0
      },
      {
        "_id": 16,
        "title": "box",
        "compact": [1, 2, 3, 4, 5, 6, 7, 14, 16, 19],
        "icon": "candlestick_chart",
        "menuLinkText": "Box Plot",
        "description": "",
        "timeSeries": true,
        "__v": 0
      },
      {
        "_id": 17,
        "title": "indicator",
        "compact": [17],
        disable: true,
        "icon": "speed",
        "menuLinkText": "Gauge Charts",
        "description": "",
        "timeSeries": false,
        "__v": 0
      },
      {
        "_id": 18,
        "compact": [18],
        "title": "scatter",
        "icon": "scatter_plot",
        "menuLinkText": "Scatter Chart",
        "description": "",
        "__v": 0
      },
      {
        "_id": 20,
        "compact": [20],
        "title": "table chart",
        "icon": "table_chart",
        "menuLinkText": "Table Chart",
        "description": "",
        "__v": 0
      },
      {
        "_id": 21,
        "compact": [21],
        "title": "histogram",
        "icon": "bar_chart",
        "menuLinkText": "Histogram",
        "description": "",
        "__v": 0
      }
    ]
  }
  userFacilityList: any = [];


  constructor(public http: HttpClient,
    private readonly userService: UserService,
    private readonly layoutUtilsService: LayoutUtilsService) { }

  saveDashboardView(data: Partial<widgetDashboard>) {
    let url = API_URL + '/api/dashboard';
    return this.http.put(url, data, { headers: this.userService.getHttpAuthHeader() });
  }

  addNewWidget(data, multi = 0) {
    let url = API_URL + '/api/dashboard/panel';
    if (multi) {
      url += '?multi=' + multi
    }
    return this.http.post(url, data, { headers: this.userService.getHttpAuthHeader() })
  }

  updateWidget(data, multi = 0) {
    let url = API_URL + '/api/dashboard/panel?multi=' + multi;
    return this.http.put(url, data, { headers: this.userService.getHttpAuthHeader() })
  }

  getWidget(widgetId, fields = null) {
    let url = API_URL + '/api/dashboard/panel';
    let httpParams = new HttpParams().set('_id', widgetId);
    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }
    return this.http.get(url, {
      headers: this.userService.getHttpAuthHeader(),
      params: httpParams
    });
  }

  deleteWidget(dashboardId, widgetId) {
    let url = API_URL + '/api/dashboard/panel';
    let params = {
      _id: widgetId,
      dashboard: dashboardId
    }
    return this.http.delete(url, { params, headers: this.userService.getHttpAuthHeader() });
  }

  addNewDashboardView(data: Partial<widgetDashboard>) {
    let url = API_URL + '/api/dashboard';
    return this.http.post(url, data, { headers: this.userService.getHttpAuthHeader() });
  }

  deleteDashboardView(data: any) {
    let url = API_URL + '/api/dashboard';
    let params = {
      _id: data._id
    }
    return this.http.delete(url, { params, headers: this.userService.getHttpAuthHeader() });
  }

  getDashBoardWidgets(queryParams: { projectionFields?: string[], type?: string } = {}) {
    let url = API_URL + '/api/dashboard';
    let params = new HttpParams();
    if (queryParams?.projectionFields || queryParams?.type) {
      if (queryParams?.projectionFields)
        params = params.set('fields',queryParams.projectionFields.join(','));
      if (queryParams?.type) {
        params = params.set('type', 3);
      }
      return this.http.get(url, { headers: this.userService.getHttpAuthHeader(),params});
    }
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader()});
  }

  getTableTagsData(payload) {
    let url = API_URL + '/api/dashboard/panel/table-data';
    return this.http.post(url, payload, { headers: this.userService.getHttpAuthHeader() });
  }

  getDashBoardWidget(dashboardId, fields = null) {
    let url = API_URL + '/api/dashboard';
    let httpParams = new HttpParams().set('_id', dashboardId);
    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }
    return this.http.get(url, {
      headers: this.userService.getHttpAuthHeader(),
      params: httpParams
    });
  }
  showToastMessage(_saveMessage) {
    this.layoutUtilsService.showActionNotification(_saveMessage, MessageType.Create, 10000, true);
  }

  getDGRReport(facilityId) {
    let url = `${API_URL}/api/downloadDGRReport?facility=${facilityId}`;
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader().set('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'), responseType: 'blob' });
  }

  prepareTimeRange(timeRangeId, customRange) {
    let tempTo = moment()
    let tempFrom = moment()
    moment.updateLocale('en', {
      week: {
        dow: 1 // Monday is the first day of the week
      }
    });
    switch (`${timeRangeId}`) {
      case "1":
        //last 1 hour
        tempFrom = tempFrom.subtract(1, 'hours')
        break
      case "2":
        //last 4 hour
        tempFrom = tempFrom.subtract(4, 'hours')
        break
      case "3":
        //last 8 hour
        tempFrom = tempFrom.subtract(8, 'hours')
        break
      case "4":
        //last 12 hour
        tempFrom = tempFrom.subtract(12, 'hours')
        break
      case "5":
        //last 24 hour
        tempFrom = tempFrom.subtract(24, 'hours')
        break
      case "6":
        //Today
        tempFrom = tempFrom.startOf('days')
        break
      case "7":
        //Yesterday: from = yesterday midnight, to = yesterday 11:59:59 pm
        tempFrom = tempFrom.subtract(1, 'days').startOf('day')
        tempTo = tempTo.subtract(1, 'days').endOf('day')
        break
      case "8":
        //last 7 days
        tempFrom = tempFrom.subtract(7, 'days').startOf('day')
        console.log(tempFrom.toISOString(), tempTo.toISOString())
        break
      case "9":
        //This week: from = Monday midnight, to = now (current time)
        tempFrom = tempFrom.startOf('week')
        break
      case "10":
        //Previous week: from = last week Monday midnight, to = this week Sunday 11:59:59 pm
        tempFrom = tempFrom.subtract(1, 'weeks').startOf('week')
        tempTo = tempTo.subtract(1, 'weeks').endOf('week')
        break
      case "11":
        //last 15 days
        tempFrom = tempFrom.subtract(15, 'days').startOf('day')
        break
      case "12":
        //last 30 days
        tempFrom = tempFrom.subtract(30, 'days').startOf('day')
        break
      case "13":
        //This Month: from = 1st of current month midnight, to = now (current time)
        tempFrom = tempFrom.startOf('month')
        break
      case "14":
        //Previous Month: from = 1st of previous month midnight, to = last date of previous month 11:59:59 pm
        tempFrom = tempFrom.subtract(1, 'months').startOf('month')
        tempTo = tempTo.subtract(1, 'months').endOf('month')
        break
      case "15":
        //last 3 months
        tempFrom = tempFrom.subtract(3, 'months').startOf('day')
        break
      case "16":
        //last 6 months
        tempFrom = tempFrom.subtract(6, 'months').startOf('day')
        break
      case "17":
        //last 12 months
        tempFrom = tempFrom.subtract(12, 'months').startOf('day')
        break
      case "18":
        //This Year: from = 1st Jan current year midnight, to = now (current time)
        tempFrom = tempFrom.startOf('year')
        break
      case "19":
        //Previous year: from = 1st Jan previous year midnight, to = 31st Dec previous year 11:59:59 pm
        tempFrom = tempFrom.subtract(1, 'years').startOf('year')
        tempTo = tempTo.subtract(1, 'years').endOf('year')
        break
      case "20": // This Quarter
        tempFrom = tempFrom.startOf('quarter');
        break;
      case "21": // Previous Quarter
        tempFrom = tempFrom.subtract(1, 'quarters').startOf('quarter');
        tempTo = tempTo.subtract(1, 'quarters').endOf('quarter');
        break;
      case "99":
        tempFrom = moment(customRange.from).startOf('day')
        tempTo = moment(customRange.to).endOf('day')
        break
      default:
        tempFrom = tempFrom.subtract(6, 'days').startOf('day')
        break
    }
    return { from: tempFrom.toISOString(), to: tempTo.toISOString() }
  }

  getTagValue(data, isTreeData = false, timeRange = 1, customRange = { from: '', to: '' }, panelFilters = null, extraParams = { 'old': true }) {
    let range = this.prepareTimeRange(timeRange, customRange)
    let params = {}
    if (extraParams['old']) {
      params = {
        "range": range,
        "data": data,
        "old": extraParams.hasOwnProperty('old') ? extraParams['old'] : true, //default is true
        "isTreeData": isTreeData
      }
    } else {
      params = { ...data }
      params['range'] = range
    }
    if (panelFilters) {
      params['filterOption'] = panelFilters
    }
    let url = API_URL + '/api/tag/dashboard';
    return this.http.post(url, params, { headers: this.userService.getHttpAuthHeader() });

  }

  getMongoPanelData(mongoPanelData, timeRangeId = 1, customRange = { from: '', to: '' }, isHistogram = false,
    slicerOptions = [], slicerFilters = []) {
    let dateRange = this.prepareTimeRange(timeRangeId, customRange);
    let url = API_URL + `/api/mongo-analytics/data${!isHistogram ? '-new' : ''}`;
    let params = { data: mongoPanelData, ...(!isHistogram ? { range: dateRange } : dateRange) }
    if (slicerOptions.length) {
      params['slicerOptions'] = slicerOptions;
    }
    if (slicerFilters.length) {
      params['slicerFilters'] = slicerFilters;
    }
    return this.http.post(url, params, { headers: this.userService.getHttpAuthHeader() });
  }

  getMongoTableData(mongoPanelData, timeRangeId = 1, customRange = { from: '', to: '' }, slicerOptions = []) {
    let dateRange = this.prepareTimeRange(timeRangeId, customRange);
    let url = API_URL + '/api/mongo-analytics/data-new';
    let params = { data: mongoPanelData, range: {...dateRange} }
    if (slicerOptions.length) {
      params['slicerOptions'] = slicerOptions;
    }
    return this.http.post(url, params, { headers: this.userService.getHttpAuthHeader() });
  }

  getDrilldownData(drillDownBody: IDrillDownObject) {
    const url = API_URL + '/api/mongo-analytics/drilldown';
    return this.http.post(url, drillDownBody, { headers: this.userService.getHttpAuthHeader() })
  }

  getDrilldownDataNew(drillDownBody: IGroupByChartDrillDownObject) {
    const url = API_URL + '/api/mongo-analytics/drilldown-new';
    return this.http.post(url, drillDownBody, { headers: this.userService.getHttpAuthHeader() })
  }

  sortGraphByName = (a, b) => {
    return a.menuLinkText.localeCompare(b.menuLinkText);
  }

  getGraphType(id = null) {
    let graphTypes = [...this.graphTypes['Non Time Series'].sort((a, b) => this.sortGraphByName(a, b)), ...this.graphTypes['Time Series'].sort((a, b) => this.sortGraphByName(a, b))]
    if (!id)
      return this.graphTypes
    return graphTypes.find(f => f._id == id)
  }
  setAxisRange(widget, axis, graphOptions) {
    if (+widget.graphOptions?.miscSettings?.range?.min || +widget.graphOptions?.miscSettings?.range?.max || widget.graphOptions?.miscSettings?.range?.min === 0 || widget.graphOptions?.miscSettings?.range?.max === 0) {
      let min = widget.graphOptions.miscSettings.range.min == 0 || widget.graphOptions.miscSettings.range.min ? widget.graphOptions.miscSettings.range.min : ''
      let max = widget.graphOptions.miscSettings.range.max == 0 || widget.graphOptions.miscSettings.range.max ? widget.graphOptions.miscSettings.range.max : ''
      graphOptions.layout[`${axis}axis`]['range'] = [min, max]
      graphOptions.layout[`${axis}axis`]['autorange'] = false
    } else {
      graphOptions.layout[`${axis}axis`]['autorange'] = true
      delete graphOptions.layout[`${axis}axis`]['range']
    }
    let val = axis === 'x' ? 'y' : 'x'
    delete graphOptions.layout[`${val}axis`]['range']
    graphOptions.layout[`${val}axis`]['autorange'] = true
    return graphOptions
  }

  getGraphTypes(ids) {
    let graphTypes = [...this.graphTypes['Non Time Series'], ...this.graphTypes['Time Series']]
    return graphTypes.filter(item => ids.includes(item._id))
  }
  isTimeSeriesGraph(id) {
    let graph = this.graphTypes['Time Series'].find(g => g._id == id);
    if (graph) {
      return true
    }
    return false;
  }
  getLegendPositioneCharts(legendPosition, lengendOrientation) {
    let position = {};
    position['orient'] = lengendOrientation === 'h' ? 'horizontal' : 'vertical';
    if (legendPosition === 1) {
      position['left'] = 'left'
      position['top'] = 'top'
    } else if (legendPosition === 2) {
      if (position['orient'] === 'vertical') {
        position['right'] = 'right'
      } else position['left'] = 'right'
      position['top'] = 'top'
    } else if (legendPosition === 3) {
      position['left'] = 'left'
      position['top'] = 'bottom'
    } else if (legendPosition === 4) {
      if (position['orient'] === 'vertical') {
        position['right'] = 'right'
      } else position['left'] = 'right'
      position['top'] = 'bottom'
    }
    return position;
  }

  legendPosition(pos, overlapLegend, orientation) {
    let position = { x: 0, y: 0 }
    if (pos === 1) {
      position.y = 1.15
      if (overlapLegend === false && orientation === 'v') {
        position.x = -0.2
        position.y = 1
        position["xanchor"] = 'right'
      } else {
        position["xanchor"] = 'left'
        position["yanchor"] = 'top'
      }
    }
    else if (pos === 2) {
      position.x = 1
      position.y = 1.15
      if (overlapLegend === false && orientation === 'v') {
        position.y = 1
        position["xanchor"] = 'left'
      } else {
        position["xanchor"] = 'right'
        position["yanchor"] = 'top'
      }
    }
    else if (pos === 3) {
      position.x = 0
      position.y = 0
      if (overlapLegend === false && orientation === 'v') {
        position.x = -0.2
        position["xanchor"] = 'right'
        position["yanchor"] = 'top'
      } else if (overlapLegend === false && orientation === 'h') {
        position.y = -0.3
        position['xanchor'] = 'left'
        position["yanchor"] = 'bottom'
      } else {
        position["xanchor"] = 'left'
        position["yanchor"] = 'bottom'
      }

    }
    else if (pos === 4) {
      position.x = 1
      if (overlapLegend === false && orientation === 'v') {
        position["xanchor"] = 'left'
        position["yanchor"] = 'top'
      } else if (overlapLegend === false && orientation === 'h') {
        position.y = -0.3
        position['xanchor'] = 'right'
        position["yanchor"] = 'bottom'
      } else {
        position["xanchor"] = 'right'
        position["yanchor"] = 'bottom'
      }
    }

    return position;
  }

  formatExtraInputsData(data, graphType, objToArray) {
    let res;
    if (objToArray) {
      res = Object.keys(data).map(k => {
        let configObj = this.chartMetaData[graphType]?.extraInputs.filter(c => c.key == k)
        configObj = configObj?.length ? configObj[0] : null
        return { ...configObj, 'value': data[k] }
      })
    } else {
      //array to object
      res = {}
      data.forEach(obj => {
        res[obj.key] = obj.value
      })
    }
    return res
  }
  getLabel(panelDataNew, id) {
    let data = panelDataNew.find(d => d.id == id || d.tag[0]?.tagId == id)
    return data?.label
  }

  getTsTable(systems, calculatedTag, systemId = '') {
    if (systemId) {
      for (const sys of systems) {
        if (sys._id === systemId) {
          return sys.tsTable;
        }
      }
    }
    else {
      if (systems?.length) {
        for (const sys of systems) {
          if (sys.deployedVersion) {
            return sys.tsTable;
          }
        }
      }
    }
    if (!calculatedTag) {
      return systems ? systems[0]?.tsTable : {};
    }
  }
  getSystemName(system) {
    if (system?.length) {
      for (const sys of system) {
        if (sys.deployedVersion) {
          return sys.name;
        }
      }
    }
    return '';
  }

  setTimeRangeDate(dashboard_id, timeRangeObj) {
    this.timeRangeData[dashboard_id] = timeRangeObj
  }

  getTimeRangeDate(dashboard_id) {
    return this.timeRangeData[dashboard_id]
  }

  setWidgetData(widgetId, data) {
    this.widgetData[widgetId] = data
  }
  getWidgetData(widgetId = null) {
    if (!widgetId) {
      return this.widgetData
    }
    const widgetData = this.widgetData[widgetId];
    return widgetData
  }
  setDashboard(dashboards) {
    this.dashboards = dashboards
  }
  getDashboard(dashboardId = null) {
    if (!dashboardId) {
      return this.dashboards
    }
    let selectedDashBoard = this.dashboards.find(dash => dash?._id == dashboardId)
    return selectedDashBoard
  }
  devide(n) {
    let result = []
    if (n <= 4) {
      return [n];
    }
    let fours = Math.floor(n / 4);
    let remainder = n % 4;
    result = new Array(fours).fill(4)
    if (remainder === 1) { // if remainder 1 --> then remove last element(which is 4) and push 3,2 to make minimal difference between each array element
      result.pop()
      result.push(3, 2)
    } else if (remainder === 2) { // if remainder 2 --> then remove last element(which is 4) and push 3,3 to make minimal difference between each array element
      result.pop()
      result.push(3, 3)
    } else if (remainder === 3) {
      result.push(3)
    }
    return result
  }

  getFieldDistinctValues(params) {
    let url = API_URL + '/api/mongo-analytics/distinct-fields-values';
    return this.http.post(url, params, { headers: this.userService.getHttpAuthHeader() })
  }

  hexToRgba(hex, opacity) {
    hex = hex.replace('#', '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  groupDivide(n) {
    let result = new Array(parseInt(n / 3 + '')).fill(3);
    if (n % 3 === 0) {
      return result;
    }
    if (n % 3 === 1) {
      if (result.length > 0) {
        result[result.length - 1] = 2;
        result.push(2);
      } else {
        result = [1];
      }
      return result;
    }
    if (n % 3 === 2) {
      if (result.length > 0) {
        result.push(2);
      } else {
        result = [2];
      }
      return result;
    }
  }
}
